import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import {ElTabs, ElTabPane, ElCarousel, ElCarouselItem, ElMenu, ElMenuItem, ElButton, ElAffix, ElEmpty, ElRow, ElCol} from 'element-plus'

import { Swipe, SwipeItem } from 'vant';
import 'vant/lib/index.css';
import webImg from './assets/solution/a3.png'
import preview from './assets/img/preview.png'
const app = createApp(App)

router.beforeEach(()=>{
    document.body.scrollTop = document.documentElement.scrollTop = 0;
})
app.use(Swipe)
app.use(SwipeItem)
// app.use(ElementPlus)
app.use(ElTabs)
app.use(ElTabPane)
app.use(ElCarousel)
app.use(ElCarouselItem)
app.use(ElMenu)
app.use(ElMenuItem)
app.use(ElButton)
app.use(ElAffix)
app.use(ElEmpty)
app.use(ElRow)
app.use(ElCol)
app.use(router)
app.mount('#app')
app.config.globalProperties.baseUrl = 'http://114.117.199.127:8056'
// app.config.globalProperties.baseUrl = 'http://114.117.199.127:8056'
app.config.globalProperties.webImg = webImg
app.config.globalProperties.preview = preview
// app.config.globalProperties.$baseUrl = 'http://192.168.1.10:8887'
// createApp(App).mount('#app')
